import { useState } from 'react'
import { useLogin } from '../api/hooks.js'

/**
 * One field, one button.
 *
 * The instrument-panel register the rest of the app uses starts here: a mono
 * label in small caps, a thin rule, and the accent used once — on the button
 * that does the thing.
 */
export function Login() {
  const [password, setPassword] = useState('')
  const login = useLogin()

  return (
    <div className="flex min-h-dvh items-center justify-center bg-[var(--bg)] px-6 safe-x">
      <form
        className="w-full max-w-sm"
        onSubmit={(e) => {
          e.preventDefault()
          login.mutate(password)
        }}
      >
        <div className="mb-8">
          <div className="tabular text-[11px] uppercase tracking-[0.18em] text-[var(--text-subtle)]">
            UT Austin · Fall 2026
          </div>
          <h1 className="mt-1 text-2xl font-semibold tracking-tight text-[var(--text)]">Semester tracker</h1>
          <div className="mt-4 h-px w-full bg-[var(--rule)]" />
        </div>

        <label htmlFor="password" className="tabular mb-2 block text-[11px] uppercase tracking-[0.12em] text-[var(--text-muted)]">
          Password
        </label>
        <input
          id="password"
          type="password"
          autoComplete="current-password"
          autoFocus
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="tap w-full rounded-[var(--radius)] border border-[var(--border)] bg-[var(--surface)] px-3 py-2.5 text-[var(--text)] outline-none focus:border-[var(--accent)]"
        />

        {login.isError && (
          <p role="alert" className="mt-3 text-sm text-[var(--overdue)]">
            {(login.error as Error).message}
          </p>
        )}

        <button
          type="submit"
          disabled={login.isPending || password === ''}
          className="tap mt-5 w-full rounded-[var(--radius)] bg-[var(--accent)] px-4 py-2.5 font-medium text-[var(--accent-contrast)] transition-colors hover:bg-[var(--accent-hover)] disabled:opacity-45"
        >
          {login.isPending ? 'Checking…' : 'Sign in'}
        </button>

        <p className="tabular mt-6 text-center text-[11px] text-[var(--text-subtle)]">
          Stays signed in for the semester
        </p>
      </form>
    </div>
  )
}
